import React, { PropsWithChildren } from "react";

import Link from "next/link";

import ArrowRight from "assets/iconsv2/arrow-right-16.svg";

import styles from "./BlockCallToAction.module.css";

type PropTypes = {
  href: string;
  target?: string;
  rel?: string;
};

const BlockCallToAction: React.FC<PropsWithChildren<PropTypes>> = ({ children, href, target, rel }) => {
  return (
    <div className={styles.blockContainer}>
      <Link href={href}>
        <a target={target} className={styles.blockCallToAction} rel={rel}>
          {children}
          <ArrowRight className="icon" />
        </a>
      </Link>
    </div>
  );
};

export default BlockCallToAction;
